import { module } from 'stereomodularjs';
import { LuminousGallery } from 'luminous-lightbox';
// Import navigation module from swiper


export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.gallery = new LuminousGallery(document.querySelectorAll('.c-gallery__item'), {}, {
            caption: function (trigger) {
                return trigger.querySelector('img').getAttribute('alt');
            }
        });
    }
}
